(function ($) {
  DJ.addBehavior('schoolFilter', '.program-offer', {
    attach: function () {
      const changeYear = $('select', $(this));
      const dataTerm = $('[data-term]');
      const dataFilterTerm = $('[data-filter-term]');
      const insertParam = (key, value) => {
        const $key = encodeURIComponent(key);
        const $value = encodeURIComponent(value);

        let s = document.location.search;
        const kvp = `${$key}=${$value}`;

        const r = new RegExp(`(&|\\?)${$key}=[^&]*`);

        s = s.replace(r, `$1${kvp}`);

        if (!RegExp.$1) {
          s += (s.length > 0 ? '&' : '?') + kvp;
        }

        document.location.search = s;
      };

      changeYear.on('change', function (e) {
        e.preventDefault();
        insertParam('year', $(e.target).val());
      });

      dataTerm.attr('hidden', '');
      dataFilterTerm.first().addClass('active');

      const updateTerm = () => {
        dataTerm.attr('hidden', '');
        $(`[data-term='${$('[data-filter-term].active').data('filter-term')}']`).removeAttr('hidden');
        jcf.refreshAll();
      };

      dataFilterTerm.on('click', (e) => {
        e.preventDefault();
        $('[data-filter-term]').removeClass('active');
        $(e.target).addClass('active');
        updateTerm();
      });

      updateTerm();
    }
  });
})(jQuery);
